<tec-modal [isVisible]="isVisible"
	[title]="'CONNECTIONS.IRPF.HELP.TITLE' | translate"
	(closeEvent)="closeModal()">
	<ng-container body>
		<tec-tile>
			<div class="image-icon-group">
				<tec-icon name="icon-smartphone" size="md"></tec-icon>
				<tec-info-group [label]="'CONNECTIONS.IRPF.HELP.PHONE_TITLE' | translate">
					<span [innerHTML]="'CONNECTIONS.IRPF.HELP.PHONE_DESCRIPTION' | translate"></span>
				</tec-info-group>
			</div>
			<tec-divider></tec-divider>
			<div class="image-icon-group">
				<tec-icon name="icon-check-circle" size="md"></tec-icon>
				<tec-info-group [label]="'CONNECTIONS.IRPF.HELP.EXPIRED_TITLE' | translate">
					<span [innerHTML]="'CONNECTIONS.IRPF.HELP.EXPIRED_DESCRIPTION' | translate"></span>
				</tec-info-group>
			</div>
			<tec-divider></tec-divider>
			<div class="image-icon-group">
				<tec-icon name="icon-card" size="md"></tec-icon>
				<tec-info-group [label]="'CONNECTIONS.IRPF.HELP.AUTOMATIC_TITLE' | translate">
					<span [innerHTML]="'CONNECTIONS.IRPF.HELP.AUTOMATIC_DESCRIPTION' | translate"></span>
				</tec-info-group>
			</div>
		</tec-tile>
		<!-- <span class="text-align-center" [innerHTML]="'CONNECTIONS.IRPF.HELP.DESCRIPTION' | translate"></span>
        <img src="assets/images/irpf-help.png" alt=""> -->
	</ng-container>
</tec-modal>
